import { useCallback } from 'react';
import { ISignal, useCustomFetch } from "../custom-fetch";
import IAuditTrail from "../shared/IAuditTrail";

interface IFetchAuditTrails extends Partial<ISignal> {
  kind?: string;
  targetId?: string;
  action?: string;
  limit?: number;
}

export const useAuditTrailService = () => {
  const customFetch = useCustomFetch();

  const fetchAuditTrails = useCallback(async ({ signal, kind, targetId, action, limit }: IFetchAuditTrails) => {
    let url = `/json/audit-trails?`;
    if (kind) url += `kind=${kind}&`;
    if (targetId) url += `targetId=${targetId}&`;
    if (action) url += `action=${action}&`;
    if (limit) url += `limit=${limit}&`;
    
    const [auditTrails] = await customFetch<IAuditTrail[]>(url, { signal });
    return auditTrails;
  }, [customFetch]);

  return { fetchAuditTrails };
}
